import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { every } from 'lodash';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { UserSession } from 'src/app/models/usersession';
import { AlertService } from 'src/app/services/alert.service';
import { ExcelService } from 'src/app/services/excel.service';
import { kcbtApiService } from 'src/app/services/kcbtApi';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserSessionService } from 'src/app/services/usersession.service';

@Component({
    selector: 'app-bvg',
    templateUrl: './bvg.component.html',
    styleUrls: ['./bvg.component.scss'],
    standalone: false
})
export class BvgComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup
  data: any[] = [];
  displayedColumns: string[] = [
      "date",
      "time",
      "name",
      "grivanceCategoryName",
      "redirectFromDesc",
      "redirectDesc",
      "currentStatusDesc",
      "action",
  ];
  dataSource = new MatTableDataSource(this.data);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static:true}) sort: MatSort;
  catogeryType: any[];
  UserId: any;
  hideEdit: number;
  excelColumns: string[];
  loading: boolean;
  bvgData: Subscription;

  constructor(
    private apiService: kcbtApiService,
    private formBuilder: UntypedFormBuilder,
    private navigate: NavigationService,
    private alertService: AlertService,
    private userService: UserSessionService,
    private excelService: ExcelService
  ) { 
    this.UserId = this.userService.roleId();
    console.log(this.UserId, "ID");
  }
  
  ngOnInit(): void {
    this.initialValidators()
    this.dataSource = new MatTableDataSource(this.data)
    this.dataSource.paginator = this.paginator;
    this.getAllBvg();
    this.getGrievanceCatogeryDrop();
  }

  initialValidators() {
    this.form = this.formBuilder.group({
      'categoryType': ['']
    })
  }

  refresh() {
    location.reload();
  }

  applyFilter(event: any): void {
    const data = (event.target as HTMLInputElement).value;
    this.dataSource.filter = data.toLowerCase().trim();
    if(this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getAllBvg() {
    this.bvgData = this.apiService.getBVG().subscribe((res) => {
      if(res.length > 0 ) {
        this.data = res;
        this.data.sort((a, b) => moment(b.date).diff(moment(a.date)));
          if(this.UserId == 9) {
            this.hideEdit = 9;
            this.data = this.data.filter((item) => item.currentStatusType !== 1 && item.currentStatusType !== 2);
          } else if(this.UserId == 2) {
            this.hideEdit = 2;
            this.data = this.data.filter((item) => item.currentStatusType !== 1 && item.currentStatusType !== 2);
          } else if(this.UserId == 4) {
            this.hideEdit = 4;
            this.data = this.data;
          }  else if(this.UserId == 1) {
            this.hideEdit = 9;
            this.data = this.data.filter((item) => item.currentStatusType !== 1 && item.currentStatusType !== 2);
          }
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      } else {
        this.alertService.warning('No Data Found')
      }
    })
  }

  getGrievanceCatogeryDrop() {
    this.apiService.getGrievanceCatogeryDrop((res) => {
      this.catogeryType = res;
    })
  }

  moveToAction(id, actionInfo) {
    this.navigate.gotoBvgaAction(id, actionInfo)
  }

  onExportExcel() {
    this.loading = true;
    setTimeout(() => {
      var exportData = this.dataSource.data;
      if (!exportData || exportData.length === 0) {
        this.alertService.info("No data available to export");
        return;
      }
      let name: string;
      name = "Grievance Report";
      this.excelColumns = [
        'Date',
        'Time',
        'Name',
        'Category',
        'Redirect From',
        'Redirect To',
        'Status',
        'Description',
      ];
      const excelList = [];
      exportData.forEach((a) => {
        excelList.push({
          date: moment(a.date).format("DD-MM-YYYY"),
          time: moment(a.date).format("hh:MM:SS"),
          name: a.name,
          grivanceCategoryName: a.grivanceCategoryName,
          redirectFromDesc: a.redirectFromDesc == '' ? '-' : a.redirectFromDesc,
          redirectDesc: a.redirectDesc == '' ? '-' : a.redirectDesc,
          currentStatusDesc: a.currentStatusDesc,
          grievanceDescription: a.grievanceDescription,
        });
      });
      this.excelService.exportAsExcelFile(excelList, name, this.excelColumns);
      this.loading = false;
    }, 500);
  }

  ngOnDestroy(): void {
    this.bvgData.unsubscribe();
  }
}
